<template>
  <div class="page pyms" :style="bgimg">
    
    <div :class="contentClass">
      <div class="tab-title">
        <img :src="title">
      </div>
      <m-textarea :class="ruClass" v-html="content"></m-textarea>
      <ul class="sub-tabs">
        <li
          v-for="(item, index) in tabs[currentTab].subtabs"
          :class="subTabClass(index)"
          :key="index"
          @click="subContect(index)"
        >
          <div v-html="item"></div>
        </li>
      </ul>
    </div>
    
    <BottomNav
      :page="page"
      :items="tabs"
      :active="currentTab"
      :class="lngClass"
      btnclass="pyms-nav"
      @changeNav="changeTab"
      wrap
    ></BottomNav>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";

import BottomNav from "@/components/BottomNav.vue";
import TextArea from "@/components/TextArea.vue";

export default {
  components: {
    BottomNav,
    "m-textarea": TextArea
  },
  data() {
    return {
      page: "pyms",
      currentTab: 0,
      curretTabName: "ybxs",
      title: "img/pyms/pyms-tt.png",
      subTab: 0,
      baseUrl: process.env.BASE_URL
    };
  },
  computed: {
    ...mapState({
      tabs: state => state.tabs.pyms,
      pyms: "pyms",
      locale: "locale"
    }),
    ...mapGetters(["lngClass"]),
    bgimg() {
      const bg = this.tabs[this.currentTab].bgimg;
      return { backgroundImage: `url("${bg}")` };
    },
    contentClass() {
      return `${this.page}-tabs`;
    },
    content() {
      const tabData = this.pyms[this.curretTabName];
      if (tabData) {
        return tabData[this.subTab];
      }
    },
    ruClass() {
      return this.locale === "ru" ? "is-ru-text" : "";
    }
  },
  mounted() {
    this.getSubContent({
      page: this.page,
      tab: this.curretTabName,
      subtab: this.tabs[this.currentTab].subtabs.length
    });
  },
  methods: {
    ...mapActions(["getSubContent"]),
    changeTab(activeNum) {
      const tabName = this.tabs[activeNum].name;
      const subtabs = this.tabs[activeNum].subtabs.length;
      this.getSubContent({
        page: this.page,
        tab: tabName,
        subtab: subtabs
      });
      this.currentTab = activeNum;
      this.curretTabName = tabName;
      this.subTab = 0;
    },
    subTabClass(index) {
      return index === this.subTab ? "active" : "";
    },
    subContect(index) {
      this.subTab = index;
    }
  }
};
</script>

<style lang="scss">
@import "../assets/base";
.pyms {
  .bottom-nav.lng {
    bottom: 0.5rem;
  }
}
.pyms-nav {
  margin: 0 1rem;
  @include tab2;

  .icon {
    width: 3.5rem;
    height: 3.5rem;
    background-size: 3rem 3rem;
  }
}

.pyms-tabs {
  position: relative;
  height: 100vh;
  background-size: cover;

  .tab-title {
    position: absolute;
    right: 1rem;
    top: 2rem;
    @include scaleimg(0.5);
    transform-origin: right top;
  }

  @media (max-width: 320px) {
    .tab-title {
      @include scaleimg(0.45);
      transform-origin: right top;
    }
  }

  .textarea {
    margin-left: 5rem;
    margin-top: 2rem;
    width: 55vw;
    font-size: 0.875rem;

    @include title-h3(0.875rem);

    &.is-ru-text {
      h4 {
        font-weight: 500;
      }
    }
  }

  .sub-tabs {
    position: absolute;
    top: 10vh;
    left: 0.5rem;

    li {
      margin: 0.5rem;
      background-image: url("~@/assets/img/subtabs-d.png");
      background-size: 100%;
      font-size: 0.625rem;
      font-weight: 900;
      text-align: center;
      color: $primary;

      div {
        display: table-cell;
        width: 3.125rem;
        height: 3.125rem;
        vertical-align: middle;
      }
    }

    li.active {
      background-image: url("~@/assets/img/subtabs-a.png");
      color: $text-dark;
    }
  }
}
</style>
